import React from 'react';

import { OptimizedImage, ImageData } from 'shared/components/ui/optimized-image/optimized-image';
import { MovesEnum } from 'shared/constants/shared-enums';

import paper from 'assets/png/moves/paper.png?format=webp;avif&as=picture';
import rock from 'assets/png/moves/rock.png?format=webp;avif&as=picture';
import scissors from 'assets/png/moves/scissors.png?format=webp;avif&as=picture';

interface IconProps {
  src: ImageData;
  alt: string;
  label: string;
  left: boolean;
}

const Icon: React.FC<IconProps> = ({ src, alt, label, left }) => (
  <div className="my-2.5 flex h-[34px] w-[44px] flex-col items-center rounded-[7px] sm:h-[58px] sm:w-[54px]">
    <OptimizedImage
      imageData={src}
      alt={alt}
      className={`w-[23px] sm:w-[40px] ${left ? 'scale-x-[-1]' : ''}`}
    />
    <p className={`text-center text-[9px] text-simple-text sm:text-[12px]`}>{label}</p>
  </div>
);

export const renderIcon = (move?: MovesEnum, left?: boolean) => {
  switch (move) {
    case MovesEnum.Paper:
      return <Icon src={paper} alt="paper" label="Paper" left={left} />;
    case MovesEnum.Rock:
      return <Icon src={rock} alt="rock" label="Rock" left={left} />;
    case MovesEnum.Scissors:
      return <Icon src={scissors} alt="scissors" label="Scissors" left={left} />;
    default:
      return null;
  }
};
